import StatusHandler from 'app/shared-components/StatusHandler'
import useFieldsWithClassName from 'app/hooks/useFieldsWithClassName'
import DomainObjectForm from 'app/shared-components/DomainObjectForm'
import useEnumValues from 'app/hooks/useEnumValues'

import useGetAccountLane from 'app/Apps/AccountManagement/AccountLanes/hooks/useGetAccountLane'
import getFields from './upcomingLaneOverview.fields'
import useStyles from './UpcomingLaneOverview.styles'

const UpcomingLaneOverview = ({
    id,
}: {
    id: number
}) => {
    const getAllowedValues = useEnumValues()
    const {
        classes,
    } = useStyles()

    const {
        data,
        isDataReady,
        isError,
        error,
        isFetching,
    } = useGetAccountLane(id)

    const fieldsWithClassName = useFieldsWithClassName(getFields(getAllowedValues), classes)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <DomainObjectForm
                name="UpcomingLanesOverview"
                disabled
                value={data}
                className={classes.gridWrapper}
                fields={fieldsWithClassName}
            />
        </StatusHandler>
    )
}

export default UpcomingLaneOverview
